// UserList Component - Display connected users
// Based on documentation showing user circles and status

import React from 'react';
import { initialsFrom } from '../utils/helpers';
import '../styles/UserList.css';

const UserList = ({ users, currentUser, onUserClick }) => {
  if (!users || users.length === 0) return null;

  return (
    <div className="user-list">
      {users.map((user) => {
        const isCurrentUser = user.peerId === currentUser?.peerId;
        const isActive = user.status === 'active';
        // User is on call if video or audio is enabled (check both status and enabled properties)
        const isOnCall = user.video?.status || user.audio?.status || user.video?.enabled || user.audio?.enabled || !user.audio?.muted;
        
        return (
          <div
            key={user.peerId}
            className={`user-circle ${isCurrentUser ? 'current-user' : ''} ${isActive ? 'active' : 'inactive'} ${isOnCall ? 'on-call' : ''}`}
            onClick={() => onUserClick && onUserClick(user)}
            title={`${user.userName || user.peerName || user.initial} - ${user.status}${isOnCall ? ' (On Call)' : ''}`}
            style={{ 
              backgroundColor: user.color || '#999',
              '--user-color': user.color || '#999'
            }}
          >
            <span className="user-initial">
              {user.initial || initialsFrom(user.userName || user.peerName || 'U')}
            </span>
            {isActive && <div className="user-status-dot"></div>}
          </div>
        );
      })}
    </div>
  );
};

export default UserList;
